import { pricingTableStyle } from './styles';

export const TablePricingView: React.FC<{ dataTestid: string }> = ({ dataTestid, children }) => {
  return (
    <table data-testid={dataTestid} className={pricingTableStyle}>
      {children}
    </table>
  );
};
